__turbopack_context__.v({
  "Cta": "NavbarPrimary-module-scss-module__kKTuKW__Cta",
  "IsActive": "NavbarPrimary-module-scss-module__kKTuKW__IsActive",
  "IsOpen": "NavbarPrimary-module-scss-module__kKTuKW__IsOpen",
  "IsToggle": "NavbarPrimary-module-scss-module__kKTuKW__IsToggle",
  "Item": "NavbarPrimary-module-scss-module__kKTuKW__Item",
  "Link": "NavbarPrimary-module-scss-module__kKTuKW__Link",
  "List": "NavbarPrimary-module-scss-module__kKTuKW__List",
  "Navbar": "NavbarPrimary-module-scss-module__kKTuKW__Navbar",
  "Search": "NavbarPrimary-module-scss-module__kKTuKW__Search",
  "SearchLink": "NavbarPrimary-module-scss-module__kKTuKW__SearchLink",
  "ToggleButton": "NavbarPrimary-module-scss-module__kKTuKW__ToggleButton",
  "ToggleButtonIcon": "NavbarPrimary-module-scss-module__kKTuKW__ToggleButtonIcon",
});
